import moment from "moment";
import React, { useEffect, useReducer, useCallback } from "react";
import { useRef } from "react";
import { addTestResult } from "../../api/addTestResult";
import darkStarIcon from "../../assets/icon/darkStarIcon.svg";
import starIcon from "../../assets/icon/starIcon.svg";
import TestQues from "../../components/testQues/testQues";
import { getStudentData } from "../../helper/localStorage";
import { totalTimeOrScore } from "../../helper/scoreCounter";
import { answeredQues } from "../../helper/testHelper";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";
import "./choiceReaction.scss";
const initialValue = {
  userTapStart: false,
  hideStar: false,
  correctPosition: null,
  userTapFlag: 0,
  userTapFirst: { position: null, correct: 0, timeTaken: 10000 },
  userTapSec: { position: null, correct: 0, timeTaken: 10000 },
  totalTimeTaken: 10000,
  starShown: false,
  startTime: {},
  tapBefore: false,
  tapAfter: false,
  isNext: false,
  actualStartTime: "", //test start from the beginning
  starShownStartTime: {},
  // starShownStartTime: moment(),
  showStar: false,
};

const getAns = (payload, startTime, starShownStartTime, tapNumber) => {
  let timeTaken = 10000;
  let correct = 0;
  let starShownTimeTaken = 10000;
  if (payload.isCorrect) {
    timeTaken = moment().diff(startTime);
    correct = 1;
    starShownTimeTaken = moment().diff(starShownStartTime);
    console.log(
      `${tapNumber} timetaken(startTime), timeTaken(starShownStartTime) `,
      timeTaken,
      starShownTimeTaken
    );
  }
  // 14 june 2021 because of optimization changes.
  // startTime starting when currentPosition is set
  // whereas the star are shown when currentPosition is set and showStar is true
  return { timeTaken: starShownTimeTaken, correct, position: payload.position };
};

const reducer = (state, action) => {
  switch (action.type) {
    case "TEST_STARTED": {
      return { ...state, actualStartTime: moment() };
    }
    case "START_CLICK": {
      return { ...state, userTapStart: true };
    }
    case "SCREEN_SHOW":
      return { ...state, starShown: true };

    // start time when the stars are diaplayed
    case "SHOW_STAR":
      return { ...state, showStar: true };

    case "SHOW_STAR_START_TIME":
      return { ...state, starShownStartTime: moment() };

    case "HIDE_STAR":
      // return { ...state, hideStar: true };
      return { ...state, hideStar: true, showStar: false };

    case "CORRECT_POSITION":
      return { ...state, correctPosition: action.payload, startTime: moment() };

    case "USER_TAP_FIRST":
      // for calculating timeSpend when the stars appear
      const ansFirst = getAns(
        action.payload,
        state.startTime,
        state.starShownStartTime,
        "first Tap"
      );
      //
      return {
        ...state,
        userTapFlag: 1,
        // totalTimeTaken: getAns(action.payload, state.startTime).timeTaken,
        // userTapFirst: getAns(action.payload, state.startTime),

        // for calculating timeSpend when the stars appear
        totalTimeTaken: ansFirst.timeTaken,
        userTapFirst: ansFirst,
      };

    case "USER_TAP_SEC":
      const timeTaken1 = state.userTapFirst.timeTaken;
      // const timeTaken2 = getAns(action.payload, state.startTime).timeTaken;

      // for calculating timeSpend when the stars appear
      const ansSecond = getAns(
        action.payload,
        state.startTime,
        state.starShownStartTime,
        "second Tap"
      );
      const timeTaken2 = ansSecond.timeTaken;
      const totalTimeTaken = Math.floor((timeTaken1 + timeTaken2) / 2);
      return {
        ...state,
        userTapFlag: 2,
        totalTimeTaken,
        // userTapSec: getAns(action.payload, state.startTime),

        // for calculating timeSpend when the stars appear
        userTapSec: ansSecond,
      };

    case "TAP_BEFORE":
      return { ...state, tapBefore: true };

    case "TAP_AFTER":
      return { ...state, tapAfter: true };

    case "MOVE_TO_NEXT":
      return { ...state, isNext: true };

    case "RESET":
      console.log("inside Reset");
      return { ...initialValue };

    default:
      return { ...state };
  }
};

export default function ChoiceReaction({ question, questions, index }) {
  const { answerC, dispatchAnswer } = AnswerContext();
  const { helperC, dispatchHelper } = HelperContext();

  const [CR, dispatchCR] = useReducer(reducer, initialValue);
  const afterTimeout = useRef(null);
  const autoAppearStartTimer = useRef(null);

  const clickableBtnRefs = useRef([]);
  const startBtnDivRef = useRef([]);

  const {
    userTapStart,
    starShown,
    correctPosition,
    userTapFlag,
    userTapFirst,
    userTapSec,
    hideStar,
    totalTimeTaken,
    tapBefore,
    tapAfter,
    isNext,
    actualStartTime,
    showStar,
  } = CR;

  useEffect(() => {
    if (userTapStart) {
      afterTimeout.current = setTimeout(() => {
        dispatchCR({ type: "TAP_AFTER" });
      }, 9000);
      const noTapTimeOut = setTimeout(() => {
        dispatchCR({ type: "MOVE_TO_NEXT" });
      }, 10000);
      return () => {
        clearTimeout(afterTimeout.current);
        clearTimeout(noTapTimeOut);
      };
    }
  }, [userTapStart]);

  useEffect(() => {
    if (isNext) {
      console.log("timeTaken on before next");
      handleNext();
    }
  }, [isNext]);

  useEffect(() => {
    // console.log("useEffect that should run only one time");
    dispatchCR({ type: "RESET" });
    dispatchCR({ type: "TEST_STARTED" });
    autoAppearStartTimer.current = setTimeout(() => {
      handleStartClick();
    }, 10000);
    return () => clearTimeout(autoAppearStartTimer.current);
  }, []);

  // for clickable box key press
  useEffect(() => {
    document.addEventListener("keyup", clickableKeyupHandler);

    return () => {
      document.removeEventListener("keyup", clickableKeyupHandler);
    };
  });

  const getRandomBtw = (min, max) => {
    let rand = Math.random() * (max - min) + min;
    rand = Math.floor(rand);
    return rand;
  };

  const starAppear = () => {
    let first = getRandomBtw(1, 5);
    let second = getRandomBtw(1, 5);
    while (first === second) {
      first = getRandomBtw(1, 5);
      second = getRandomBtw(1, 5);
    }
    return { first, second };
  };

  const handleStartClick = () => {
    clearTimeout(autoAppearStartTimer.current);
    dispatchCR({ type: "START_CLICK" });
    // console.log("CR.startTime", CR.startTime);
    console.log("userTapStart", userTapStart);
    if (!userTapStart) {
      const rand = getRandomBtw(4, 10);
      const timer = setTimeout(() => {
        clearTimeout(timer);
        if (!correctPosition) {
          dispatchCR({ type: "CORRECT_POSITION", payload: starAppear() });
          //
          // setTimeout(() => {
          //   if (!hideStar) {
          //     dispatchCR({ type: "HIDE_STAR" });
          //   }
          // }, 400);
          //
        }
      }, rand * 100);
    }
  };

  const handleNext = () => {
    const isCorrect = userTapFirst.correct === 1 && userTapSec.correct === 1;

    const nextTest = questions[index + 1];
    const answer_flag = tapBefore
      ? "Too Early"
      : tapAfter
      ? "Too Late"
      : !isCorrect
      ? "Incorrect"
      : "Correct";

    const value = { userTapFirst, userTapSec, totalTimeTaken, answer_flag };
    const timeSpend = moment().diff(actualStartTime);

    if (helperC.testType === "CALIBRATION") {
      dispatchAnswer({
        type: "ADD_ANSWER",
        payload: answeredQues("choice_reactionCal", value, question, timeSpend),
      });
    } else {
      dispatchAnswer({
        type: "ADD_ANSWER",
        payload: answeredQues("choice_reaction", value, question, timeSpend),
      });
    }

    // FIXME
    if (index < questions.length - 1) {
      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: nextTest && nextTest.id,
      });
    } else {
      // this condition run at end of the question
      let answerRes = [
        ...answerC.answers,
        answeredQues("choice_reaction", value, question, timeSpend),
      ];
      const grade_id = JSON.parse(localStorage.getItem("gradeId"));
      const { login_id } = getStudentData();
      const { player_time, player_score } = totalTimeOrScore(
        answerRes,
        questions,
        true
      );
      answerRes = answerRes.map((answer) => {
        return { ...answer, answer: "" };
      });
      const formatValue = {
        grade_id,
        player_id: login_id,
        res: answerRes,
        player_image: "",
        player_time,
        player_score,
        test_id: question.test_id,
      };

      // api hitting to send data to server
      addTestResult(formatValue, dispatchHelper, dispatchAnswer);
      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: "submitted",
      });
    }
  };

  const handleUserTap = (position) => {
    // if there is a start and there is a position
    clearTimeout(afterTimeout.current);
    if (!tapBefore) {
      // if (hideStar && correctPosition !== null) {
      // 14 june 2021
      // early tap only when star is not show
      if ((hideStar || showStar) && correctPosition !== null) {
        if (userTapFlag === 0) {
          // handle first tap
          const correctPositions =
            position === correctPosition.first ||
            position === correctPosition.second;
          if (correctPositions) {
            // handle second tap
            dispatchCR({
              type: "USER_TAP_FIRST",
              payload: { isCorrect: true, position },
            });
          } else {
            dispatchCR({
              type: "USER_TAP_FIRST",
              payload: { isCorrect: false, position },
            });
          }
        } else if (userTapFlag === 1) {
          dispatchCR({ type: "USE_TAP_SEC" });
          const correctPositions =
            position === correctPosition.first ||
            position === correctPosition.second;
          if (correctPositions) {
            dispatchCR({
              type: "USER_TAP_SEC",
              payload: { isCorrect: true, position },
            });
            setTimeout(() => {
              dispatchCR({ type: "MOVE_TO_NEXT" });
            }, 1500);
          } else {
            dispatchCR({
              type: "USER_TAP_SEC",
              payload: { isCorrect: false, position },
            });
            setTimeout(() => {
              dispatchCR({ type: "MOVE_TO_NEXT" });
            }, 1500);
          }
        }
      } else {
        dispatchCR({ type: "TAP_BEFORE" });
      }
    }
  };

  // 14 june 2021 for optimization, commented out because causing unwanted rerender
  // const handleAppearStar = () => {
  //   const rand = getRandomBtw(3, 6);
  //   console.log("inside handleAppearStar");
  //   console.log();
  //   setTimeout(() => {
  //     console.log("inside HIDE_STAR settimeout");
  //     if (!hideStar) {
  //       console.log("inside HIDE_STAR settimeout if condition");
  //       dispatchCR({ type: "HIDE_STAR" });
  //     }
  //   }, 400);
  //   // for calculating timeSpend when the stars appear
  //   // setTimeout(() => {
  //   //   dispatchCR({ type: "SHOW_STAR_START_TIME" });
  //   // });
  //   // dispatchCR({ type: "SHOW_STAR_START_TIME" });
  //   return !hideStar && <img src={starIcon} alt="" className="" />;
  // };

  useEffect(() => {
    console.log(
      "inside useeffect to show_star: correctPosition, hideStar, showStar",
      correctPosition,
      hideStar,
      showStar
    );
    if (correctPosition && !hideStar && !showStar) {
      dispatchCR({ type: "SHOW_STAR" });
      setTimeout(() => {
        if (!hideStar) {
          dispatchCR({ type: "HIDE_STAR" });
        }
      }, 400);
    }

    if (showStar) {
      dispatchCR({ type: "SHOW_STAR_START_TIME" });
    }
  }, [correctPosition, hideStar, showStar]);

  const handleEarlyTap = () => {
    setTimeout(() => {
      dispatchCR({ type: "MOVE_TO_NEXT" });
    }, 1500);
    return <h3>Oops! You Tapped too early</h3>;
  };

  const handleLateTap = () => {
    setTimeout(() => {
      dispatchCR({ type: "MOVE_TO_NEXT" });
    }, 1500);
    return <h3>Oops! You Tapped too tap</h3>;
  };

  const handleTapAns = () => {
    return (
      <div className="result-screen">
        <div className=""></div>
        <div className="">TAP1</div>
        <div className="">TAP2</div>
        <div className="">RESULT</div>
        <div className="">ACCURACY</div>
        <div className="">{userTapFirst.correct}</div>
        <div className="">{userTapSec.correct}</div>
        <div className="">{userTapFirst.correct + userTapSec.correct}</div>
        <div className="">SPEED</div>
        <div className="">{userTapFirst.timeTaken}ms</div>
        <div className="">
          {(tapAfter || userTapFlag === 2) && `${userTapSec.timeTaken}ms`}
        </div>
        <div className="">{totalTimeTaken}ms</div>
      </div>
    );
  };

  const clickableKeyupHandler = useCallback((e) => {
    if (e.key === "a" || e.code === "KeyA") {
      clickableBtnRefs.current.find(({ key }) => key === "A").el.click();
    } else if (e.key === "s" || e.code === "KeyS") {
      clickableBtnRefs.current.find(({ key }) => key === "S").el.click();
    } else if (e.key === "k" || e.code === "KeyK") {
      clickableBtnRefs.current.find(({ key }) => key === "K").el.click();
    } else if (e.key === "l" || e.code === "KeyL") {
      clickableBtnRefs.current.find(({ key }) => key === "L").el.click();
    } else if (e.key === " " || e.code === "Space") {
      startBtnDivRef.current.click();
    }
  }, []);

  return (
    <div className="cr-test">
      <div
        className={`ques-screen ${userTapStart && "msgDisable"} ${
          starShown && "starShown"
        }`}
        onClick={handleStartClick}
        ref={startBtnDivRef}
      >
        <div className="random-appearing-blk">
          {[1, 2, 3, 4].map((position) => (
            <div key={position} className="appearing">
              {correctPosition &&
                correctPosition.first === position &&
                // handleAppearStar()}
                showStar && <img src={starIcon} alt="" className="" />}
              {correctPosition &&
                correctPosition.second === position &&
                // handleAppearStar()}
                showStar && <img src={starIcon} alt="" className="" />}
            </div>
          ))}
        </div>
        <div className="touch-to-start">
          <span>Touch here or Press spacebar to start</span>
        </div>
        <TestQues question={question} />
      </div>
      {/* <div className="ans-submitting-area">
        {[1, 2, 3, 4].map((position) => (
          <div
            key={position}
            className="clickable"
            onClick={() => {
              if (
                userTapFirst.position !== position &&
                userTapSec.position !== position &&
                userTapStart &&
                !tapAfter
              ) {
                handleUserTap(position);
              } else return undefined;
            }}
          >
            {userTapFirst.position === position && (
              <img src={darkStarIcon} alt="" className="" />
            )}
            {userTapSec.position === position && (
              <img src={darkStarIcon} alt="" className="" />
            )}
          </div>
        ))}
      </div> */}
      <div className="ans-submitting-area">
        {[
          { position: 1, key: "A" },
          { position: 2, key: "S" },
          { position: 3, key: "K" },
          { position: 4, key: "L" },
        ].map(({ position, key }, i) => (
          <div className="clickable-container" key={key + i}>
            <p>
              Press below box <br /> or key <span>{key}</span>
            </p>
            <div
              key={position}
              ref={(el) => clickableBtnRefs.current.push({ el, key })}
              className="clickable"
              onClick={() => {
                if (
                  userTapFirst.position !== position &&
                  userTapSec.position !== position &&
                  userTapStart &&
                  !tapAfter
                ) {
                  handleUserTap(position);
                } else return undefined;
              }}
            >
              {userTapFirst.position === position && (
                <img src={darkStarIcon} alt="" className="" />
              )}
              {userTapSec.position === position && (
                <img src={darkStarIcon} alt="" className="" />
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="msg-screen">
        {/* {userTapFirst ||  */}
        {userTapFlag > 0 && !tapAfter && handleTapAns()}
        {tapBefore && handleEarlyTap()}
        {tapAfter && handleTapAns()}
      </div>
    </div>
  );
}
